// // frontend/src/api/axiosClient.js
// import axios from "axios";

// const axiosClient = axios.create({
//   baseURL: "http://localhost:5000/api",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Function to dynamically set token
// let getToken = null; // this will be set from outside

// export const setAxiosTokenGetter = (getterFunction) => {
//   getToken = getterFunction;
// };

// // Attach token dynamically
// axiosClient.interceptors.request.use((config) => {
//   if (getToken) {
//     const token = getToken();
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//   }
//   return config;
// });

// export default axiosClient;


import axios from "axios";

const axiosClient = axios.create({
  baseURL: "http://localhost:5000/api",
});

// Attach JWT automatically
axiosClient.interceptors.request.use((config) => {
  const saved = sessionStorage.getItem("currentUser");

  if (saved) {
    const user = JSON.parse(saved);
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
  }

  return config;
});

export default axiosClient;
